/**
 * Deterministic avatar color and initial from an email or name. Same input
 * always produces the same hue so a teammate's avatar is consistent across
 * the page (toolbar, pin, popover, members list).
 */

const HUES = [
  142, // green
  210, // blue
  20,  // orange
  280, // purple
  340, // pink
  200, // teal
  35,  // amber
  260, // indigo
  170, // emerald
  0,   // red
];

export function avatarColor(seed: string | null | undefined): { bg: string; fg: string } {
  const s = (seed ?? '').toLowerCase().trim();
  let hash = 0;
  for (let i = 0; i < s.length; i++) hash = (hash * 31 + s.charCodeAt(i)) | 0;
  const hue = HUES[Math.abs(hash) % HUES.length];
  return { bg: `hsl(${hue} 65% 45%)`, fg: 'white' };
}

export function avatarInitial(seed: string | null | undefined): string {
  const s = (seed ?? '').trim();
  if (!s) return '?';
  // Prefer first letter of email local-part.
  const local = s.split('@')[0] || s;
  const word = local.replace(/[^a-zA-Z0-9]+/g, ' ').trim().split(/\s+/)[0] || s;
  return word[0]!.toUpperCase();
}

export function displayName(email: string | null | undefined): string {
  const e = (email ?? '').trim();
  if (!e) return 'Unknown';
  const local = e.split('@')[0] || e;
  // Title-case the local part: john.doe → John Doe.
  return local
    .replace(/[._-]+/g, ' ')
    .split(' ')
    .filter(Boolean)
    .map((w) => w[0]!.toUpperCase() + w.slice(1).toLowerCase())
    .join(' ');
}
